(function (window, $) {
  class Checkbox {
    constructor(options) {
      this.options = $.extend(
        {
          value: "",
          checked: false,
          disabled: false,
          label: "",
          labelSlot: null,
          container: null,
          readonly: false,
        },
        options,
      );

      this.value = this.options.value;
      this.emitter = window.useEmitter();
      this.$html = null;
      this.init();
    }

    init() {
      this.render();
      this.bindEvents();
      if (this.options.container) {
        $(this.options.container).append(this.$html);
      }
    }

    render() {
      const { checked, disabled, readonly, label, labelSlot } = this.options;

      const $wrapper = $("<div>").addClass("custom-checkbox");
      if (disabled) {
        $wrapper.addClass("is-disabled");
      }

      if (readonly) {
        $wrapper.addClass("is-readonly");
      }

      const iconClass = checked ? "icon-icon-weixuanzhongxiang1" : "icon-icon-weixuanzhongxiang2";
      const $icon = $("<i>").addClass(`iconfont ${iconClass} checkbox-icon`);

      const $label = $("<span>").addClass(`checkbox-label ${checked ? "checked" : ""}`);

      if (labelSlot) {
        if (typeof labelSlot === "function") {
          $label.html(labelSlot(this.options));
        }
        if (typeof labelSlot === "string") {
          $label.html(labelSlot);
        } else if (labelSlot instanceof jQuery || (labelSlot && labelSlot.nodeType)) {
          $label.append(labelSlot);
        }
      } else {
        $label.text(label);
      }

      $wrapper.append($icon).append($label.attr("title", label));
      this.$html = $wrapper;
    }

    bindEvents() {
      this.$html.on("click", () => {
        if (this.options.disabled || this.options.readonly) return;
        this.toggle();
      });
    }

    toggle() {
      this.setValue(!this.options.checked, true);
    }

    getValue() {
      return this.options.checked;
    }

    setValue(checked, emit = false) {
      if (this.options.checked === checked) return;
      this.options.checked = checked;
      this.updateIcon();
      emit && this.emitter.emit("change", checked, this.value);
    }

    updateIcon() {
      const $icon = this.$html.find(".checkbox-icon");
      const $label = this.$html.find(".checkbox-label");
      $icon.removeClass("icon-icon-weixuanzhongxiang1 icon-icon-weixuanzhongxiang2");
      if (this.options.checked) {
        $icon.addClass("icon-icon-weixuanzhongxiang1");
        $label.addClass("checked");
      } else {
        $icon.addClass("icon-icon-weixuanzhongxiang2");
        $label.removeClass("checked");
      }
    }

    setDisabled(disabled) {
      this.options.disabled = disabled;
      if (disabled) {
        this.$html.addClass("is-disabled");
      } else {
        this.$html.removeClass("is-disabled");
      }
    }

    setReadonly(readonly) {
      this.options.readonly = readonly;
      if (readonly) {
        this.$html.addClass("is-readonly");
      } else {
        this.$html.removeClass("is-readonly");
      }
    }

    updateData(options) {
      $.extend(this.options, options);
      if (options.hasOwnProperty("checked")) {
        this.setValue(options.checked);
      }
      if (options.hasOwnProperty("disabled")) {
        this.setDisabled(options.disabled);
      }
      if (options.hasOwnProperty("readonly")) {
        this.setDisabled(options.readonly);
      }
      if (options.hasOwnProperty("label") || options.hasOwnProperty("labelSlot")) {
        const $label = this.$html.find(".checkbox-label");
        $label.empty();
        const { label, labelSlot } = this.options;
        if (labelSlot) {
          if (typeof labelSlot === "string") {
            $label.html(labelSlot);
          } else if (labelSlot instanceof jQuery || (labelSlot && labelSlot.nodeType)) {
            $label.append(labelSlot);
          }
        } else {
          $label.text(label);
        }
      }
    }
  }

  window.Checkbox = Checkbox;
})(window, jQuery);
